import { Shimmer, ShimmerElementType } from "@fluentui/react";

import { Container } from "../../components/Invoice/styles";

import { Card } from "@/components/Shared/Card";

const shimmerConfigs = [
  {
    style: { marginBottom: "0.5rem", width: "30%" },
    elements: [{ type: ShimmerElementType.line, height: 40 }]
  },
  {
    style: { marginBottom: "0.5rem", width: "80%" },
    elements: [
      { type: ShimmerElementType.line, height: 40 },
      { type: ShimmerElementType.line, height: 40 }
    ]
  },
  {
    style: { marginBottom: "0.5rem" },
    elements: [{ type: ShimmerElementType.line, height: 330 }]
  },
  {
    style: { marginBottom: "0.5rem", width: "30%" },
    elements: [{ type: ShimmerElementType.line, height: 30 }]
  },
  {
    style: { marginBottom: "0.5rem" },
    elements: [{ type: ShimmerElementType.line, height: 50 }]
  },
  {
    style: { marginBottom: "0.5rem", width: "20%" },
    elements: [{ type: ShimmerElementType.line, height: 40 }]
  }
];

export function OwnershipTransferShimmer() {
  return (
    <Container>
      <Card
        width="60%"
        padding="2rem"
        borderRadius="0.75rem"
        margin="0 0 2rem 0"
      >
        {shimmerConfigs.map((config, index) => (
          <Shimmer
            key={index}
            style={config.style}
            shimmerElements={config.elements}
          />
        ))}
      </Card>
    </Container>
  );
}
